<template>
  <v-layout xs12>
    <v-card class="expBnrTxt">
      <v-icon style="color:white;">warning</v-icon>
      {{$t('expBnrTxt')}} {{ExpBanner}}
    </v-card>
  </v-layout>
</template>

<script>
export default {
  data() {
    return {
      ExpBanner: ''
    }
  },
  destroyed() {
    console.log('destroy')
  },
  created: function() {
    let userInfo = JSON.parse(sessionStorage.getItem('backendLoginInfo'))
    var date = new Date(userInfo.ExpireBanner).toLocaleDateString('zh-HK', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    })
    //console.log(date)

    this.ExpBanner = date
  }
}
</script>

<style>
.expBnrTxt {
  width: 100%;
  padding: 8px;
  color: white !important;
  background-color: #ff5252 !important;
  font-size: 20px;
}
</style>
